// import React, { useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import "./FabricsParatha.css";

// const CARDS = [
//   { title: "Linen",         slug: "linen",         image: "/img/fab1.webp" },
//   { title: "Banarasi",      slug: "banarasi",      image: "/img/fab2.webp" },
//   { title: "Cotton",        slug: "cotton",        image: "/img/fab3.webp" },
//   { title: "Tissue Cotton", slug: "tissue-cotton", image: "/img/fab4.webp" },
// ];

// const FabricsParatha = () => {
//   const titleRef = useRef(null);

//   /* Heading scroll par fade-in */
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("fabricsparatha-animate-in");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );

//     if (titleRef.current) observer.observe(titleRef.current);

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <section className="fabricsparatha-section">
//       <h2 className="fabricsparatha-title" ref={titleRef}>
//         Our Fabrics
//       </h2>

//       <div className="fabricsparatha-grid">
//         {/* {CARDS.map((card, index) => (
//           <Link
//             key={card.subcategory_id}
//             to={`/products?category=${card.category_id}&subcategory=${card.subcategory_id}`}
//             className={`fabricsparatha-card fabricsparatha-card-${index + 1}`}
//             aria-label={card.title}
//           >
//             <img
//               src={card.image}
//               alt={card.title}
//               className="fabricsparatha-img"
//               loading="lazy"
//               draggable={false}
//             />
//             <span className="fabricsparatha-label">{card.title}</span>
//           </Link>
//         ))} */}
//         {CARDS.map((card, index) => (
//   <Link
//     key={card.slug}
//     to={`/fabric/${card.slug}`}
//     className={`fabricsparatha-card fabricsparatha-card-${index + 1}`}
//     aria-label={card.title}
//   >
//     {/* baaki same */}
//     <img
//               src={card.image}
//               alt={card.title}
//               className="fabricsparatha-img"
//               loading="lazy"
//               draggable={false}
//             />
//             <span className="fabricsparatha-label">{card.title}</span>
//   </Link>
// ))}
//       </div>
//     </section>
//   );
// };

// export default FabricsParatha;










// 04-11-2026 dyanamic 
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./FabricsParatha.css";

const API_URL =
  "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_our_fabrics";

/* "Tissue Cotton" -> "tissue-cotton" (link ke liye, pehle jaisa /fabric/:slug) */
// const slugify = (text = "") =>
//   String(text)
//     .toLowerCase()
//     .trim()
//     .replace(/[^a-z0-9]+/g, "-")
//     .replace(/^-+|-+$/g, "");

/* API item -> card shape */
const mapCard = (item) => ({
  id: item.id,
  title: item.heading,
  // slug: slugify(item.heading),
    link: item.category_slug
    ? `/${item.category_slug}${
        Number(item.subcategory_id) > 0
          ? `?subcategory=${item.subcategory_id}`
          : ""
      }`
    : "/all-sarees",
  image: item.image_url,
});

const FabricsParatha = () => {
  const titleRef = useRef(null);

  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ---------------- API fetch ---------------- */
  useEffect(() => {
    const controller = new AbortController();

    const fetchFabrics = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(API_URL, { signal: controller.signal });
        if (!res.ok) throw new Error("Network response was not ok");
        const json = await res.json();

        const ok =
          json?.success === "1" ||
          json?.success === 1 ||
          json?.status === "true" ||
          json?.status === true;

        if (!ok || !json.data) {
          throw new Error(json?.message || "Failed to load fabrics");
        }

        // data array ho ya single object, dono handle
        const list = Array.isArray(json.data) ? json.data : [json.data];

        // A -> B: admin se jo pehla add hua wo pehle card par
        const sorted = [...list].sort((a, b) => Number(a.id) - Number(b.id));
        setCards(sorted.map(mapCard));
      } catch (err) {
        if (err.name !== "AbortError") {
          setError("Something went wrong while loading fabrics.");
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchFabrics();
    return () => controller.abort();
  }, []);

  /* Heading scroll par fade-in */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fabricsparatha-animate-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, []);

  /* Mosaic pattern 4-2-3-3 repeat hota hai.
     Agar aakhri card akela reh jaye (count % 4 == 1 ya 3) to wo poori row le leta hai. */
  const getCardClass = (index) => {
    const base = `fabricsparatha-card fabricsparatha-card-${(index % 4) + 1}`;
    const isLast = index === cards.length - 1;
    const remainder = cards.length % 4;
    const aloneInRow = isLast && (remainder === 1 || remainder === 3);
    return aloneInRow ? `${base} fabricsparatha-card-full` : base;
  };

  return (
    <section className="fabricsparatha-section">
      {/* Heading (static) */}
      <h2 className="fabricsparatha-title" ref={titleRef}>
        Our Fabrics
      </h2>

      {loading && <p>Loading...</p>}
      {!loading && error && <p>{error}</p>}
      {!loading && !error && cards.length === 0 && <p>No fabrics available.</p>}

      {!loading && !error && cards.length > 0 && (
        <div className="fabricsparatha-grid">
          {cards.map((card, index) => (
            <Link
              key={card.id}
              // to={`/fabric/${card.slug}`}
              // state={{ fabricId: card.id }}
              to={card.link}
              className={getCardClass(index)}
              aria-label={card.title}
            >
              <img
                src={card.image}
                alt={card.title}
                className="fabricsparatha-img"
                loading="lazy"
                draggable={false}
              />
              <span className="fabricsparatha-label">{card.title}</span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
};

export default FabricsParatha;